import Marquee from "react-fast-marquee";

const ITEMS = [
  { text: "Crafting Dreams", script: true },
  { text: "One Creation at a Time", script: false },
  { text: "Custom T-Shirts", script: false },
  { text: "Sweatshirts", script: false },
  { text: "Hoodies", script: false },
  { text: "Any Color", script: true },
  { text: "Your Design", script: false },
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-[#E5D8D3] bg-[#F4EAE6] py-7" data-testid="editorial-marquee">
      <Marquee speed={22} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="flex items-center" aria-hidden={i >= ITEMS.length}>
            <span
              className={`${
                item.script ? "ff-script text-3xl text-[#B08A2E]" : "ff-serif text-2xl italic text-[#1A2421]/75"
              } whitespace-nowrap`}
            >
              {item.text}
            </span>
            <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-gradient-to-br from-[#2A5C43] to-[#D87D92]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
